import { getRuntimeConfig } from "@/shared/config"

const PROD_GIFT_RELAY_BOT_USERNAME = "trix_treasury"
const STAGING_GIFT_RELAY_BOT_USERNAME = "olehvelvet"

export function getGiftRelayBotUsername(): string {
  const config = getRuntimeConfig()
  const handle =
    config.env === "prod"
      ? PROD_GIFT_RELAY_BOT_USERNAME
      : STAGING_GIFT_RELAY_BOT_USERNAME
  return handle.replace(/^@+/, "").trim()
}

export function getGiftRelayBotHandle(): string {
  return `@${getGiftRelayBotUsername()}`
}

export function getGiftRelayBotTelegramUrl(): string {
  return `https://t.me/${getGiftRelayBotUsername()}`
}
